var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.40933 0.807104C7.16859 0.619861 6.83149 0.619861 6.59075 0.807104L0.590747 5.47377C0.428356 5.60007 0.333374 5.79428 0.333374 6V13.3333C0.333374 14.4349 1.23185 15.3333 2.33337 15.3333H11.6667C12.7682 15.3333 13.6667 14.4349 13.6667 13.3333V6C13.6667 5.79428 13.5717 5.60007 13.4093 5.47377L7.40933 0.807104ZM9.66671 14H11.6667C12.0319 14 12.3334 13.6985 12.3334 13.3333V6.32606L7.00004 2.17791L1.66671 6.32606V13.3333C1.66671 13.6985 1.96823 14 2.33337 14H4.33337V8C4.33337 7.63181 4.63185 7.33334 5.00004 7.33334H9.00004C9.36823 7.33334 9.66671 7.63181 9.66671 8V14ZM5.66671 14V8.66667H8.33337V14H5.66671Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.d4b9d616.svg";
export { ForwardRef as ReactComponent };